const SMALL = 5;
const SMALL_MEDIUM = 10;
const MEDIUM = 50;
const LARGE = 100;

export const PAGINATOR_SIZE_OPTIONS = [SMALL, SMALL_MEDIUM, MEDIUM, LARGE];
